import { createReducer, on } from '@ngrx/store';
import { EstreamContractStatus } from 'brain-data/model/estream-contract-status.model';
import {
  loadEstreamContractStatus,
  loadEstreamContractStatusError,
  loadEstreamContractStatusSuccess,
} from '../actions/estream-contract-status.action';

export default interface EstreamContractStatusState {
  statusByContract: { [contractNumber: string]: EstreamContractStatus };
  loadingByContract: { [contractNumber: string]: boolean };
  errorByContract: { [contractNumber: string]: Error };
}

export const initialState: EstreamContractStatusState = {
  statusByContract: {},
  loadingByContract: {},
  errorByContract: {},
};

const keyOf = (contractNumber: string): string => contractNumber.trim();

export const reducer = createReducer(
  initialState,
  on(loadEstreamContractStatus, (state, { contractNumber }): EstreamContractStatusState => ({
    ...state,
    loadingByContract: { ...state.loadingByContract, [keyOf(contractNumber)]: true },
  })),
  on(loadEstreamContractStatusSuccess, (state, { contractNumber, status }): EstreamContractStatusState => {
    const key = keyOf(contractNumber);
    const nextLoading = { ...state.loadingByContract };
    delete nextLoading[key];
    return {
      ...state,
      statusByContract: { ...state.statusByContract, [key]: status },
      loadingByContract: nextLoading,
    };
  }),
  on(loadEstreamContractStatusError, (state, { contractNumber, error }): EstreamContractStatusState => {
    const key = keyOf(contractNumber);
    const nextLoading = { ...state.loadingByContract };
    delete nextLoading[key];
    return {
      ...state,
      loadingByContract: nextLoading,
      errorByContract: { ...state.errorByContract, [key]: error },
    };
  }),
);
